import $ from "jquery";




export default class Accordion {
	constructor() {
		$(document).on("ready", () => {
			this.contentHandler();
		});
	}

	contentHandler = () => {
        $('#accordion').find('.accordion-toggle').click(function(){

           let isActive = $(this).hasClass("active");
            $('.accordion-toggle').removeClass('active')
				if (!isActive) {
					$(this).toggleClass('active');
				}
            $(this).next().slideToggle('fast');
            $(".accordion-content").not($(this).next()).slideUp('fast');

        });
	};
}



// WEBPACK FOOTER //
// ./src/js/components/accordion.js